import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        let anchor = window.location.hash;
        $(this.element).find(`a[href="${anchor}"]`).first().tab('show')
    }
}

